import { render, staticRenderFns } from "./ItemCardDefault.vue?vue&type=template&id=c7f0c9fa&scoped=true&"
import script from "./ItemCardDefault.vue?vue&type=script&lang=js&"
export * from "./ItemCardDefault.vue?vue&type=script&lang=js&"
import style0 from "./ItemCardDefault.vue?vue&type=style&index=0&id=c7f0c9fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f0c9fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VAvatar,VBtn,VCard,VChip,VHover,VIcon,VRating})
